var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331,
    height: 22,
    viewBox: "0 0 331 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Text",
    transform: "translate(0 17)",
    fill: "#1a1a1a",
    fontSize: 16,
    fontFamily: "OpenSans, Open Sans",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "We\u2019ve updated the changes on your profile."))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Text.058042ab8bc329cae92495d7ef146eed.svg";